import React from 'react'
import {Input, Label} from 'reactstrap'
import PropTypes from 'prop-types'

const PermissionCheckboxListItem = (props) => {
    return (
        <div className="d-flex flex-row">
            <Label check>
                <Input
                    type="checkbox"
                    checked={props.checked}
                    onChange={(evt) => props.onChange(props.permission_id, evt.target.checked)}
                />{' '}
                {props.name}
            </Label>
        </div>
    )
}

PermissionCheckboxListItem.propTypes = {
    permission_id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
}

export default PermissionCheckboxListItem